import type { NodeObject } from '3d-force-graph';

export enum GalaxyNodeType {
  ORIGIN = 'origin',
  SPIRAL = 'spiral',
  CLUSTER = 'cluster',
  STAR = 'star',
  PLANET = 'planet',
}

export class GalaxyNode implements NodeObject {
  id: string;
  index?: number | undefined;
  x?: number | undefined;
  y?: number | undefined;
  z?: number | undefined;
  vx?: number | undefined;
  vy?: number | undefined;
  vz?: number | undefined;
  fx?: number | undefined;
  fy?: number | undefined;
  fz?: number | undefined;

  constructor(
    public name: string,
    public type: GalaxyNodeType,
    public ringIndex: number = 0,
    public data?: any,
  ) {
    const randomStr = Math.random().toString(10).slice(2, 6);
    this.id = `${name}_${type}_${randomStr}`;
  }
}

export const ORIGIN_NODE = new GalaxyNode('Galaxy Center', GalaxyNodeType.ORIGIN);
